let timeout: ReturnType<typeof setTimeout> | null = null;

const debounce = <F extends (...args: any[]) => any>(func: F, waitFor: number) => {
  const debounced = (...args: Parameters<F>) => {
    if (timeout !== null) {
      clearTimeout(timeout);
      timeout = null;
    }
    timeout = setTimeout(() => func(...args), waitFor);
  };

  return debounced as (...args: Parameters<F>) => ReturnType<F>;
};

export default debounce;
